import {
  AssignTechnicianResponse,
  JobDetailResponse,
  JobOrderReorderPayload,
  JobPayload,
  JobResponse,
  SubJobPayload,
  TechnicianAssigmentPayload,
} from "@/hooks/services/pps/types/job-orders.type";
import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";

export const JobOrderList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `JobOrderList_${stringParams}`,
    handle: (): Promise<JobResponse> =>
      apiCall<JobResponse>({
        params,
        url: ENDPOINT.JOB_ORDERS,
        method: HttpMethod.GET,
      }),
  };
};

export const JobOrderDetail = (id: number | string) => {
  return {
    name: `JobOrderDetail`,
    handle: (): Promise<JobDetailResponse> =>
      apiCall<JobDetailResponse>({
        url: `${ENDPOINT.JOB_ORDER}/${id}`,
        method: HttpMethod.GET,
      }),
  };
};

export const CreateSubJobOrder = () => {
  return {
    name: "CreateSubJobOrder",
    handle: (body: SubJobPayload): Promise<JobResponse> =>
      apiCall<JobResponse>({
        url: `${ENDPOINT.JOB_ORDER}/sub`,
        method: HttpMethod.POST,
        body,
      }),
  };
};

// THE OTHER METHOD LIKE PUT, POST, DELETE MAY HAVE THIS HANDLER STRUCTURE
export const UpdateJobOrder = () => {
  return {
    name: "UpdateJobOrder",
    handle: ({ jobId, jobData }: JobPayload): Promise<JobResponse> =>
      apiCall<JobResponse>({
        url: `${ENDPOINT.JOB_ORDER}/${jobId}`,
        method: HttpMethod.PUT,
        body: jobData,
      }),
  };
};

export const UpdateBulkJobOrder = () => {
  return {
    name: "UpdateBulkJobOrder",
    handle: (body: any[]): Promise<JobResponse> =>
      apiCall<JobResponse>({
        url: `${ENDPOINT.JOB_ORDER}/bulk`,
        method: HttpMethod.PUT,
        body,
      }),
  };
};

export const DeleteJobOrder = () => ({
  name: "SoftDeleteJobOrder",
  handle: (body: { jobOrderIds: number[] }): Promise<JobResponse> =>
    apiCall<JobResponse>({
      url: `${ENDPOINT.JOB_ORDER}/delete`,
      method: HttpMethod.POST,
      body: body,
    }),
});

export const UpdateJobOrderStatus = () => {
  return {
    name: "UpdateJobOrderStatus",
    handle: ({ jobId, statusId }: any): Promise<JobResponse> => {
      return apiCall<JobResponse>({
        url: `${ENDPOINT.JOB_ORDER}/${jobId}/status`,
        method: HttpMethod.PUT,
        body: {
          statusId,
        },
      });
    },
  };
};

export const AssignJobOrderTechnician = () => {
  return {
    name: "AssignJobOrderTechnician",
    handle: ({
      jobOrderId,
      technicianIds,
    }: TechnicianAssigmentPayload): Promise<AssignTechnicianResponse> =>
      apiCall<AssignTechnicianResponse>({
        url: `${ENDPOINT.JOB_ORDER}/${jobOrderId}/assign-technicians`,
        method: HttpMethod.POST,
        body: { technicianIds },
      }),
  };
};

export const UnAssignJobOrderTechnician = () => {
  return {
    name: "UnAssignJobOrderTechnician",
    handle: ({
      jobOrderId,
      technicianIds,
    }: TechnicianAssigmentPayload): Promise<AssignTechnicianResponse> => {
      return apiCall<AssignTechnicianResponse>({
        url: `${ENDPOINT.JOB_ORDER}/${jobOrderId}/unassign-technicians`,
        method: HttpMethod.DELETE,
        body: { technicianIds },
      });
    },
  };
};

export const UpdateJobOrderReorder = () => {
  return {
    name: "UpdateJobOrderReorder",
    handle: (body: JobOrderReorderPayload): Promise<JobResponse> =>
      apiCall<JobResponse>({
        url: `${ENDPOINT.JOB_ORDER}/reorder`,
        method: HttpMethod.PUT,
        body,
      }),
  };
};
